/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Preview_Text_LabelInputs */

const en_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview Text`)
};

const fr_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte d'aperçu`)
};

const de_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschautext`)
};

const it_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima testo`)
};

const ru_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр текста`)
};

const es_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del texto`)
};

const zh_cn2_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览文本`)
};

const ja_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューテキスト`)
};

const hi_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन पाठ`)
};

const pt_pt2_voice_manager_preview_text_label = /** @type {(inputs: Voice_Manager_Preview_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto de pré-visualização`)
};

/**
* | output |
* | --- |
* | "Preview Text" |
*
* @param {Voice_Manager_Preview_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_preview_text_label = /** @type {((inputs?: Voice_Manager_Preview_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Preview_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_preview_text_label(inputs)
	if (locale === "de") return de_voice_manager_preview_text_label(inputs)
	if (locale === "it") return it_voice_manager_preview_text_label(inputs)
	if (locale === "ru") return ru_voice_manager_preview_text_label(inputs)
	if (locale === "es") return es_voice_manager_preview_text_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_preview_text_label(inputs)
	if (locale === "ja") return ja_voice_manager_preview_text_label(inputs)
	if (locale === "hi") return hi_voice_manager_preview_text_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_preview_text_label(inputs)
	return en_voice_manager_preview_text_label(inputs)
});